module.exports = __webpack_public_path__ + "img/mira-certidao.8aa51e3d.svg";